import { scaleW } from '@/common/style';
import { KImage, KImageBackground } from '@/component/RtlLayout';
import React from 'react';
import { View, Text } from 'react-native';
import ArrowRight from '@/assets/icon_detail/arrow_right.png';
import { KTouchableWithoutFeedback } from '@/component/RtlLayout/Touchable';
import { useDetailLogger } from '../../../logger3.0';
import { ViewVisible } from '@/component/ViewVisible/ViewVisible';
import { useDetailPageStore } from '@/page/detail/store';
import { openUrlV2 } from '@/common/bridge/openUrl';

export function ProductRank() {
    const { logClickRankBanner, logShowRankBanner } = useDetailLogger();
    const pageRawData = useDetailPageStore(s => s.pageRawData);
    const rankInfo = pageRawData.categoryRankingPageInfo;
    const goToRank = () => {
        logClickRankBanner();
        if (rankInfo.rankingPageUrl) {
            openUrlV2({
                url: rankInfo.rankingPageUrl,
            });
        }
    };
    if (!rankInfo?.productRankTip) return null;
    return (
        <ViewVisible onVisible={logShowRankBanner}>
            <View style={{"height":"6.280193236714976rem","borderRadius":"1.4492753623188408rem","width":"100%","alignItems":"center","marginTop":"2.8985507246376816rem"}}>
                <KImageBackground
                    source={{ uri: rankInfo.backImageUrl }}
                    style={{"width":"90.82125603864735rem","height":"6.280193236714976rem"}}>
                    <KTouchableWithoutFeedback onPress={goToRank}>
                        <View
                            style={{"width":"90.82125603864735rem","height":"6.280193236714976rem","flexDirection":"row","justifyContent":"space-between","paddingHorizontal":"1.9323671497584543rem","alignItems":"center"}}>
                            <View style={{"flexDirection":"row","alignItems":"center"}}>
                                {rankInfo.logoImageUrl ? (
                                    <KImage
                                        source={{ uri: rankInfo.logoImageUrl }}
                                        style={{"width":"3.8647342995169085rem","height":"3.8647342995169085rem","marginRight":"0.9661835748792271rem"}}
                                    />
                                ) : null}
                                <Text style={{"fontSize":"2.8985507246376816rem","color":"white","maxWidth":"79.71014492753623rem"}} numberOfLines={1} ellipsizeMode="tail">
                                    {rankInfo.productRankTip}
                                </Text>
                            </View>
                            <KImage source={ArrowRight} style={{"width":"3.8647342995169085rem","height":"3.8647342995169085rem"}} />
                        </View>
                    </KTouchableWithoutFeedback>
                </KImageBackground>
            </View>
        </ViewVisible>
    );
}
